<template>
	<div>
		<b-modal
			id="interviewPrepModal"
			centered
			hide-footer
			hide-header
			v-model="localShowMod"
			@hidden="closeModals()"
		>
			<div id="hideinmobile" class="candash-modal-top p-3 pl-4">
				<div class="width-97">
					<span class="candash-modal-head">Interview Preparation</span>
				</div>

				<img
					@click="closeModals()"
					class="rotate-on-hover pointer"
					src="../../assets/newdesign/dashboard/blueCross.svg"
					alt=""
				/>
			</div>
			<div
				id="hideinlaptop"
				class="d-flex justify-content-center mt-4 mb-grey-txt-3"
			>
				Interview Preparation
			</div>
			<main class="d-flex flex-column align-items-center py-4 px-5 gap-4">
				<img
					src="../../assets/newdesign/myprofile/interviewPrepModal.svg"
					alt=""
				/>
				<h3 class="upCandDoc-unselected-box-head-2 mb-0 text-center">
					Please add relevant skills to your resume so we can assist you in
					preparing for your interview.
				</h3>
				<b-button
					@click="fromAnotherPage ? gotoDash() : openSkillForm()"
					class="candash-addBtn-sm px-4"
					>Add skills</b-button
				>
			</main>
		</b-modal>
	</div>
</template>
<script>
import EventBus from "../../utils/EventBus";
export default {
	name: "NoSkillsPrepareInterview",
	components: {},
	mixins: [],
	props: {
		showMod: {
			type: Boolean,
			default: false,
		},
		fromAnotherPage: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			localShowMod: this.showMod,
			isLaptop: true,
		};
	},
	created() {},
	computed: {},
	watch: {
		showMod(newVal) {
			// Watch for changes to the prop and update the local data property
			this.localShowMod = newVal;
		},
		localShowMod(newVal) {
			// Emit an event when the localShowMod changes to notify the parent
			this.$emit("update:showMod", newVal);
		},
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		closeModals() {
			// this.$bvModal.hide('interviewPrepModal')
			this.localShowMod = false;
			this.$emit("close-modal", this.localShowMod);
		},
		openSkillForm() {
			this.closeModals();
			this.$bvModal.hide("interviewPrepModal");
			if (this.isLaptop) {
				EventBus.$emit("openSkForm", true);
			} else {
				this.$router.push({
					name: "MobileForm",
					query: {
						formID: "skills",
					},
				});
			}
		},

		gotoDash() {
			this.closeModals();
			if (this.isLaptop) {
				this.$router.push({
					path: "/dashboard",
					query: { openfrom: "openSkills" },
				});
			} else {
				this.$router.push({
					name: "MobileForm",
					query: {
						formID: "skills",
					},
				});
			}
		},
		// goToInterviewPrep() {
		// 	const OnlySkills = this.candidateInfo.skills.filter(
		// 		(link) => link.parser != true
		// 	);
		// 	if (OnlySkills.length > 0) {
		// 		this.$router.push({ name: "PrepareInterview" });
		// 	} else {
		// 		this.$bvModal.show("interviewPrepModal");
		// 	}
		// },
	},
};
</script>
<style lang="" scoped></style>
